import React from 'react';
import {
  EntityCriteriaCompoundOperatorInput,
  RelatedEntityConfigInput,
  TieredEntitySelectionInput,
} from '../../../../types/generated-types';

import { EntitySelectionBuilder } from './EntitySelectionBuilder';

export const TieredEntitySelectionBuilder = ({
  value,
  onChangedValue,
}: {
  value: TieredEntitySelectionInput;
  onChangedValue: (updatedValue: TieredEntitySelectionInput) => void;
  onClose: () => void;
}) => {
  const [myValue, setMyValue] =
    React.useState<TieredEntitySelectionInput | null>(null);

  React.useEffect(() => {
    setMyValue(value ?? null);
  }, [value]);

  const handleUpdateRequest = React.useCallback(
    (
      updatedValue: EntityCriteriaCompoundOperatorInput,
      updatedRelatedEntityFilters: RelatedEntityConfigInput[],
    ) => {
      console.log(JSON.stringify(value, null, 2));
      if (myValue) {
        onChangedValue({
          ...myValue,
          selectionCriteria: updatedValue,
          targetModel: {
            ...myValue.targetModel,
            relatedEntities: updatedRelatedEntityFilters,
          },
        });
      }
    },
    [myValue, onChangedValue, value],
  );

  return myValue ? (
    <div>
      {myValue ? (
        myValue.targetModel ? (
          <EntitySelectionBuilder
            value={myValue.selectionCriteria}
            relatedEntityFilters={myValue.targetModel.relatedEntities ?? []}
            onUpdateRequest={handleUpdateRequest}
            targetModel={myValue.targetModel.modelName}
            tiers={myValue.tiers ?? 1}
          />
        ) : (
          <div>No target model</div>
        )
      ) : (
        <div>No value</div>
      )}
    </div>
  ) : null;
};
